import { render, staticRenderFns } from "./DomainDetailsTab.vue?vue&type=template&id=0bd3fc54&scoped=true&"
import script from "./DomainDetailsTab.vue?vue&type=script&lang=js&"
export * from "./DomainDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd3fc54",
  null
  
)

export default component.exports